import { keyValueService } from 'reactor-js-core/dist/services/keyvalueservice.js'
import Vue from 'vue';

var key_value_state = {
  namespaced: true,
  state() {
    return {
      groupId: {},
      keyValues: {}
    }
  },
  mutations: {
    setGroupId(state, group_id) {
      state.groupId = group_id;
    },
    internalSetKeyValues(state, key_values) {
      state.keyValues = Object.assign({}, state.keyValues, key_values);
    },
    internalRemoveKeys(state, keys) {
      for(var key of keys) {
        Vue.delete(state.keyValues, key);
      }
    }
  },
  getters: {
    keyValues: state => {
      return state.keyValues;
    }
  },
  actions: {
    subscribeToKeyValues(context, group_id) {
      context.commit('setGroupId', group_id);
      var sub = keyValueService.subscribeToKeyValueGroup({group: {type: group_id.type, typeId: group_id.typeId, group: group_id.group}}, response => {},
      {
        'KeyValueGroupInitialData': data => {
          if (data.group.type != group_id.type|| data.group.typeId != group_id.typeId || data.group.group != group_id.group) return;

          context.commit('internalSetKeyValues', data.keyValues);
          if (group_id.initialDataCallback) {
            group_id.initialDataCallback();
          }
        },
        'KeyValueGroupUpdated': data => {
          if (data.group.type != group_id.type || data.group.typeId != group_id.typeId || data.group.group != group_id.group) return;

          context.commit('internalSetKeyValues', data.updatedKeyValues);
        },
        'KeyValueGroupRemoved': data => {
          if (data.group.type != group_id.type || data.group.typeId != group_id.typeId || data.group.group != group_id.group) return;

          context.commit('internalRemoveKeys', data.removedKeys);
        }
      });
      return sub;
    },
    setKeyValues(context, key_values) {
      return keyValueService.setGroupKeyValues({
        group: context.state.groupId,
        keyValues: key_values
      });
    },
    removeKeyValues(context, keys) {
      return keyValueService.removeGroupKeyValues({
        group: context.state.groupId,
        keys: keys
      });
    }
  }
}

var currentSubscriptions = {};

export default {
  namespaced: true,
  state() {
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    subscribeToKeyValues(context, group_id) {
      var id_str = group_id.type + "/" + group_id.typeId + "/" + group_id.group;
      var existing_subscription = currentSubscriptions[id_str];
      if (existing_subscription == null) {
        var vuex_module_name = "keyvalues/" + id_str;
        console.log("Registering keyvalue vuex store at " + vuex_module_name);
        this.registerModule(vuex_module_name, key_value_state);
        var sub = context.dispatch(id_str + "/subscribeToKeyValues", group_id);
        var sub_obj = {
          count: 1,
          subscription: sub
        }

        sub_obj.unsubscribe = () => {
          sub_obj.count--;
          if (sub_obj.count == 0) {
            sub_obj.subscription.then(sub => sub.unsubscribe());
            console.log("Unregistering keyvalue vuex store at " + vuex_module_name);
            this.unregisterModule(vuex_module_name);
            currentSubscriptions[id_str] = null;
          }
        }

        currentSubscriptions[id_str] = sub_obj;
        return sub_obj;
      }
      else {
        existing_subscription.count++;
        return existing_subscription;
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/keyvalues.js